// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"AdminsEdit_pageHeader__18R7g AdminsList_pageHeader__3AKo3","fieldError":"AdminsEdit_fieldError__3ZFej","archiveText":"AdminsEdit_archiveText__2WINP"};